export function transformToBackendConsolidateEvent(data: any) { // eslint-disable-line
  return {
    domain_id: data.domain_id,
    process_type_id: data.process_type_id,
    event_type_id: data.event_type_id,
    event: JSON.stringify(data.event)
  };
}

export function transformFromBackendConsolidateEvent(backendType: any) { // eslint-disable-line
  return backendType;
}
